export enum LoadingState {
  Requested,
  Ready,
}

export interface LoadingObject<T> {
  value?: T;
  state: LoadingState;
}

export type SortOption = {
  id: number;
  resource: string;
  showForSearchResults: boolean;
  showForDiscountVoucher: boolean;
  shoeForBenefitBucks: boolean;
  showByDefault: boolean;
};
